import DeliveryOption from '@/controllers/options/DeliveryOption';
import DeliveryOptionConstants from '@/controllers/options/DeliveryOptionConstants';
import DeliveryOptionsProvider from '@/models/DeliveryOptionsProvider';
import IOptionHandler from './IOptionHandler';

class CalculatorOptionHandler implements IOptionHandler {
  execute(provider: DeliveryOptionsProvider, map: Map<string, unknown>): void {
    const deliveryOption: DeliveryOption | undefined = this.createDeliveryOption(
      map.get(DeliveryOptionConstants.CALCULATOR) as string
    );
    if (deliveryOption) {
      provider.addDeliveryOption(deliveryOption);
    }
  }

  private createDeliveryOption(calculatorType: string | undefined): DeliveryOption | undefined {
    if (calculatorType) {
      switch (calculatorType.toLowerCase()) {
        case 'basic': {
          return new DeliveryOption('basic-calculator');
        }
        case 'scientific': {
          return new DeliveryOption('scientific-calculator');
        }
        case 'graphing': {
          return new DeliveryOption('graphing-calculator');
        }
        default: {
          break;
        }
      }
    }
    return undefined;
  }
}

export default CalculatorOptionHandler;
